import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const supportApi = createApi({
  reducerPath: 'supportApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    sendSupport: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/support',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
    }),
  }),
});

export const { useSendSupportMutation } = supportApi;
